<template>
  <div id="order">
    <div>
      <div class="table-search-card">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :span="8">
              <a-form-item label="订单号">
                <a-input v-model="params.orderNo"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="供应商">
                <a-input v-model="params.supplierCompanyName"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-button type="primary" @click="query">查询</a-button>
              <a-button style="margin-left: 8px" @click="reset">重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table
          :loading="loading"
          rowKey="id"
          ref="table"
          size="default"
          :columns="columns"
          :dataSource="dataList"
          :pagination="{ ...pagination, current: params.current}"
      >
        <span slot="shipmentStatus" slot-scope="text">
          {{ statusMap[text] }}
        </span>
        <span slot="orderType" slot-scope="text">
          {{ text === 'supplier' ? '积分兑换' : '平台兑换' }}
        </span>
        <span slot="action" slot-scope="record">
          <a @click="visible = true, orderId = record.id">详情</a>
          <template v-if="record.orderStatus === 2">
            <a-divider type="vertical" />
            <a-popconfirm title="是否确认收货？" @confirm="takeDelivery(record)">
              <a>收货</a>
            </a-popconfirm>
          </template>
        </span>
      </a-table>
    </div>
    <order-detail :visible.sync="visible" :orderId="orderId"/>
  </div>
</template>
<script>
import {loadOrderPage, takeDeliveryOfGoods} from "@/api/account";
import OrderDetail from "@/views/account/modules/OrderDetail";
import {filterNullable} from "@/utils/chemical";
export default {
  components: {
    OrderDetail
  },
  data () {
    return {
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => `${index + 1}`
        },
        {
          title: '订单号',
          dataIndex: 'orderNo'
        },
        {
          title: '实付积分',
          dataIndex: 'totalPoints'
        },
        {
          title: '下单时间',
          dataIndex: 'orderTime'
        },
        {
          title: '成交供应商',
          dataIndex: 'supplierCompanyName'
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          scopedSlots: { customRender: 'orderType' }
        },
        {
          title: '状态',
          dataIndex: 'orderStatus',
          scopedSlots: { customRender: 'shipmentStatus' }
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataList: [],
      params: {
        size: 10,
        current: 1
      },
      visible: false,
      orderId: '',
      total: 0,
      loading: false,
      statusMap: {
        1: '待发货',
        2: '待收货',
        3: '已完成'
      }
    }
  },
  computed: {
    pagination () {
      const _this = this
      return {
        pageSize: 10,
        total: this.total,
        onChange (page, pageSize) {
          _this.params.current = page
          _this.getPage()
        }
      }
    }
  },
  mounted () {
    this.getPage()
  },
  methods: {
    takeDelivery (d) {
      takeDeliveryOfGoods(d.id).then(res => {
        if(!res.code) {
          this.$HttpHandlerService.checkCode(res, true, '操作成功')
        }
        this.getPage()
      })
    },
    getPage () {
      this.loading = true
      try {
        loadOrderPage(filterNullable({ query: {...this.params}, ...this.params })).then(res => {
          this.dataList = res.data.records
          this.total = res.data.total
        })
      } finally {
        this.loading = false
      }
    },
    query () {
      this.params.current = 1
      this.getPage()
    },
    reset () {
      this.params.orderNo = null
    }
  }
}
</script>
<style lang="less" scoped>
#order > div {
  border-radius: 10px;
  background: #fff;
  //padding: 40px;
  min-height: 705px;
}
</style>
